"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const User_1 = __importDefault(require("../entity/User"));
class UserStub extends User_1.default {
    constructor({ id = '10', name = 'Kaizen Taro', email = 'yuta.yamamoto@kaizenplatform.com', profileImageUrl = 'https://randomuser.me/api/portraits/lego/2.jpg', } = {}) {
        super({ id, name, email, profileImageUrl });
    }
}
exports.default = UserStub;
